export function saveObject(key, value) {
  window.localStorage.setItem(key, JSON.stringify(value));
}

export function getObject(key, defaultValue) {
  const value = JSON.parse(window.localStorage.getItem(key));
  if (!value) {
    saveObject(key, defaultValue);
    return defaultValue;
  }
  return value;
}

export function updateObject(key, value) {
  const current = getObject(key, {});
  saveObject(key, { ...current, ...value });
}
